import { AddressCard } from '../AddressCard'

export interface AddressesGridProps {
  addresses: Array<{
    id: string
    address: string
    label?: string | null
    chain: string
    status: string
    decisionBy?: string | null
    requester?: {
      id: string
      email: string
      username: string
    } | null
  }>
  onApprove?: (id: string) => void
  onReject?: (id: string) => void
  onManage?: (address: any) => void
  showApproveButton?: (status: string) => boolean
  showRejectButton?: (status: string) => boolean
  showManageButton?: (status: string) => boolean
  gridLayout?: 'default' | 'compact'
  className?: string
}

export function AddressesGrid({
  addresses,
  onApprove,
  onReject,
  onManage,
  showApproveButton,
  showRejectButton,
  showManageButton,
  gridLayout = 'default',
  className = '',
}: AddressesGridProps) {
  if (addresses.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="text-center">
          <p className="text-muted-foreground">No whitelisted addresses found</p>
        </div>
      </div>
    )
  }

  const gridClasses =
    gridLayout === 'compact'
      ? 'grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4'
      : 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4'

  return (
    <div className={`${gridClasses} ${className}`}>
      {addresses.map((address) => (
        <AddressCard
          key={address.id}
          address={{
            id: address.id,
            address: address.address,
            label: address.label,
            chain: address.chain,
            status: address.status,
            decisionBy: address.decisionBy,
            requester: address.requester,
          }}
          onApprove={onApprove}
          onReject={onReject}
          onManage={onManage}
          showApproveButton={showApproveButton?.(address.status) ?? false}
          showRejectButton={showRejectButton?.(address.status) ?? false}
          showManageButton={showManageButton?.(address.status) ?? false}
        />
      ))}
    </div>
  )
}
